import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { postOrQueue } from "../lib/offlineQueue";
import { useAuth } from "../context/AuthContext";
import PhotoInput from "../components/PhotoInput";

const inputCls = "mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0E2240]";

export default function Fuel() {
  const { user } = useAuth();
  const [logs, setLogs] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [show, setShow] = useState(false);
  const [f, setF] = useState({ vehicle_id: "", litres: "", amount: "", odometer: "", bill_photo: null });
  const canEdit = ["tdc", "sm", "admin"].includes(user.role);

  const load = () => { api.get("/fuel").then((r) => setLogs(r.data)); api.get("/vehicles").then((r) => setVehicles(r.data)); };
  useEffect(load, []);

  const submit = async () => {
    try {
      const res = await postOrQueue("/fuel", { ...f, litres: parseFloat(f.litres), amount: parseFloat(f.amount), odometer: parseInt(f.odometer) }, "Fuel refill");
      toast.success(res.queued ? "No network — refill saved offline and will sync automatically" : "Fuel refill logged");
      setShow(false); load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="px-4 py-5 lg:px-8 max-w-3xl">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-2xl font-bold text-[#0E2240]">Fuel Log</h1>
        {canEdit && <button data-testid="fuel-add-btn" onClick={() => setShow(!show)} className="rounded-full bg-[#BB162B] px-4 py-2 text-sm font-bold text-white">+ Refill</button>}
      </div>

      {show && (
        <div className="mt-4 space-y-3 rounded-2xl border border-slate-200 bg-white p-4">
          <select data-testid="fuel-vehicle-select" value={f.vehicle_id} onChange={(e) => setF({ ...f, vehicle_id: e.target.value })} className={inputCls}>
            <option value="">Select vehicle…</option>
            {vehicles.map((v) => <option key={v.id} value={v.id}>{v.reg_no} — {v.model}</option>)}
          </select>
          <div className="grid grid-cols-3 gap-2">
            <input data-testid="fuel-litres-input" type="number" value={f.litres} onChange={(e) => setF({ ...f, litres: e.target.value })} placeholder="Litres" className={inputCls} />
            <input data-testid="fuel-amount-input" type="number" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} placeholder="Amount ₹" className={inputCls} />
            <input data-testid="fuel-odo-input" type="number" value={f.odometer} onChange={(e) => setF({ ...f, odometer: e.target.value })} placeholder="Odometer" className={inputCls} />
          </div>
          <PhotoInput label="fuel bill" value={f.bill_photo} onChange={(b) => setF({ ...f, bill_photo: b })} testId="fuel-bill-photo-btn" />
          <button data-testid="fuel-submit-btn" onClick={submit} className="w-full rounded-xl bg-[#0E2240] py-3 text-sm font-bold text-white">Log Refill</button>
        </div>
      )}

      <div className="mt-4 space-y-2">
        {logs.map((l) => (
          <div key={l.id} className="flex items-center justify-between rounded-xl border border-slate-200 bg-white p-3 text-sm">
            <div>
              <div className="font-semibold text-[#0E2240] text-[13px]">{l.reg_no} · {l.litres} L · ₹{l.amount.toLocaleString("en-IN")}</div>
              <div className="text-[11px] text-slate-400">{l.date} · @ {l.odometer.toLocaleString("en-IN")} km · ₹{(l.amount / l.litres).toFixed(1)}/L</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
